import React, { CSSProperties } from "react";
import { IonTextarea } from "@ionic/react";

interface _Props {
    value: string;
    placeHolder?: string;
    rows?: number;
    isReadOnly?: boolean;
    isRequired?: boolean;
    saveChange?: (value: string) => void;
}

const BasicTextarea: React.FC<_Props> = ({ value, placeHolder, rows, isReadOnly, isRequired, saveChange }) => {
    return (
        <IonTextarea
            value={value}
            placeholder={placeHolder || ""}
            onIonChange={(e) => {
                if (saveChange) {
                    saveChange(e.detail.value || "");
                }
            }}
            autoGrow={true}
            rows={rows || 4}
            spellcheck={true}
            readonly={isReadOnly || false}
            aria-required={isRequired || false}
            style={
                {
                    fontSize: "14px",
                    "--padding-start": "0px",
                    "--padding-end": "0px",
                    "--padding-top": "0px",
                    "--padding-bottom": "0px",
                } as CSSProperties
            }
        />
    );
};

export default BasicTextarea;
